import { toast } from 'react-toastify';
import { t } from 'react-switch-lang';
import { runInAction } from 'mobx';
import MessageModel from '../models/MessageModel';
import chatStorage from '../pages/Chat/chatStorage';
import currentMessages from '../pages/Chat/storages/currentMessages';

class CommandsProcessor {
  static process(command) {
    switch (command.type) {
      case 'messages.notsent':
        toast.error(t(`chat.${command.error_message}`));
        break;
      case 'messages.append':
        if (command.conversation_id == chatStorage.currentChatID) {
          const chatIndex = chatStorage.conversations.findIndex((item) => item.id == command.conversation_id);
          const newMessage = new MessageModel(
            typeof command.message === 'string'
              ? JSON.parse(command.message)
              : command.message,
          );
          currentMessages.addMessage(newMessage);
        }
        break;
    }
  }
}

export default CommandsProcessor;
